module.exports = __webpack_public_path__ + "img/hunan.975e9573.png";